import React, { useState } from "react";
import { Card, Dropdown } from "react-bootstrap";
import { FiCalendar } from "react-icons/fi";

export default function TasksStatisticsCard() {

const [tooltip,setTooltip] = useState(null);

const showTooltip = (e,label,value,color)=>{
const rect = e.target.getBoundingClientRect();

setTooltip({
label,
value,
color,
x: rect.left + rect.width/2,
y: rect.top
});
};

const hideTooltip = ()=>{
setTooltip(null);
};

return(

<Card  className="task-card h-100">

<div className="task-header">

<h5>Tasks Statistics</h5>

<Dropdown>
<Dropdown.Toggle className="calendar-btn">
<FiCalendar className="me-2"/>
This Week
</Dropdown.Toggle>
</Dropdown>

</div>

<div className="task-body">

<div className="graph-container">

<svg viewBox="0 0 400 200" className="task-graph">

{/* yellow */}
<path
d="M50 170 A140 140 0 0 1 120 70"
stroke="#ffb400"
strokeWidth="38"
fill="none"
strokeLinecap="round"
onMouseEnter={(e)=>showTooltip(e,"Ongoing",24,"#ffb400")}
onMouseLeave={hideTooltip}
/>

{/* blue */}
<path
d="M120 70 A140 140 0 0 1 280 70"
stroke="#2f80ed"
strokeWidth="38"
fill="none"
strokeLinecap="round"
onMouseEnter={(e)=>showTooltip(e,"On Hold",10,"#2f80ed")}
onMouseLeave={hideTooltip}
/>

{/* light blue */}
<path
d="M280 70 A140 140 0 0 1 340 130"
stroke="#4aaad1"
strokeWidth="38"
fill="none"
strokeLinecap="round"
onMouseEnter={(e)=>showTooltip(e,"Overdue",16,"#4aaad1")}
onMouseLeave={hideTooltip}
/>

{/* green */}
<path
d="M340 130 A140 140 0 0 1 360 170"
stroke="#0f7b5f"
strokeWidth="38"
fill="none"
strokeLinecap="round"
onMouseEnter={(e)=>showTooltip(e,"Completed",40,"#0f7b5f")}
onMouseLeave={hideTooltip}
/>

</svg>

{/* center text */}

<div className="graph-center">
<p>Total Tasks</p>
<h3>124/165</h3>
</div>

</div>

{/* tooltip */}

{tooltip && (

<div
className="graph-tooltip"
style={{
top: tooltip.y - 55,
left: tooltip.x - 50
}}
>

<div className="tooltip-arrow"></div>

<strong>{tooltip.label}</strong>

<div className="tooltip-row">

<span
className="tooltip-color"
style={{background:tooltip.color}}
></span>

Semi Donut: {tooltip.value}

</div>

</div>

)}

{/* legend */}

<div className="legend">

<span><i className="dot yellow"></i> Ongoing 24%</span>

<span><i className="dot blue"></i> On Hold 10%</span>

<span><i className="dot red"></i> Overdue 16%</span>

<span><i className="dot green"></i> Completed 40%</span>

</div>

<div className="task-footer">

<h4>389/689 hrs</h4>

<p>Spent on Overall Tasks This Week</p>

</div>

</div>

<style>
{`

.task-card{
border-radius:6px;
border:1px solid #e5e7eb;
background:#ffffff;

box-shadow:0 2px 5px rgba(0,0,0,0.05);
}

.task-header{
display:flex;
justify-content:space-between;
align-items:center;
padding:15px 20px;
border-bottom:1px solid #eee;
}

.calendar-btn{
background:#fff;
border:1px solid #ddd;
}

.task-body{
padding:20px;
}

.graph-container{
position:relative;
width:100%;
}

.task-graph{
width:100%;
height:200px;
}

@media (max-width:576px){
.task-card{
margin-top:15px;
}
}

@media (max-width:992px){
.task-card{
margin-top:15px;
}
}

@media (max-width:1024px){
.task-card{
margin-top:15px;
}
}
.graph-center{
position:absolute;
top:55%;
left:50%;
transform:translate(-50%,-50%);
text-align:center;
}

.graph-center p{
margin:0;
color:#777;
font-size:14px;
}

.graph-center h3{
font-weight:700;
}

.legend{
display:flex;
justify-content:space-between;
margin-top:15px;
border-top:1px solid #eee;
padding-top:10px;
font-size:14px;
}

.dot{
width:10px;
height:10px;
border-radius:50%;
display:inline-block;
margin-right:6px;
}

.yellow{background:#ffb400;}
.blue{background:#2f80ed;}
.red{background:#ff3b30;}
.green{background:#0f7b5f;}

.task-footer{
margin-top:20px;
background:linear-gradient(90deg,#1e2229,#2a2f36);
padding:18px;
border-radius:8px;
color:white;
}

.task-footer h4{
color:#16c47f;
margin:0;
}

.task-footer p{
margin:3px 0 0;
font-size:13px;
}

/* tooltip */

.graph-tooltip{
position:fixed;
background:#333;
color:#fff;
padding:8px 12px;
border-radius:6px;
font-size:13px;
pointer-events:none;
box-shadow:0 3px 10px rgba(0,0,0,0.25);
white-space:nowrap;
z-index:999;
}

.tooltip-row{
display:flex;
align-items:center;
margin-top:3px;
font-size:12px;
}

.tooltip-color{
width:10px;
height:10px;
margin-right:6px;
border-radius:2px;
}

.tooltip-arrow{
position:absolute;
left:-6px;
top:14px;
width:0;
height:0;
border-top:6px solid transparent;
border-bottom:6px solid transparent;
border-right:6px solid #333;
}

`}
</style>

</Card>

);

}